/** This package's translations, registered at import. */

import { registerNamespace } from "@hardauto/core-i18n";

import ar from "./locales/ar.json";
import en from "./locales/en.json";
import es from "./locales/es.json";
import fr from "./locales/fr.json";

export const NAMESPACE = "admin";

registerNamespace(NAMESPACE, { en, fr, es, ar });
